export const microServices = {
  TCMSV2: "tcms/v2",
};

const endpoints = {
  CREATE_DELIVERY: `${microServices.TCMSV2}/neap-delivery/create`,
  GET_ALL_DELIVERY: `${microServices.TCMSV2}/neap-delivery/get-all-deliveries`,
  PRE_SIGNED_URL: `${microServices.TCMSV2}/neap-delivery/pre-signed-url`,
  UPLOAD_TARGET_EMP_CSV: `${microServices.TCMSV2}/neap-delivery/upload-target-employees-csv`,
  GET_TARGET_EMP_CSV: `${microServices.TCMSV2}/neap-delivery/get-target-employee-csv`,
  GET_DELIVERY_EXECUTIONS: `${microServices.TCMSV2}/neap-delivery/get-delivery-executions`,
};

export default endpoints;
